module.exports = "img#gif {\n  width: 100%;\n  margin-bottom: 1rem; }\n\n.btn-group {\n  padding: 0 2px; }\n"